let isOverdue = function(idxstatus, fecdue) {
    let f_a = new Date();
    let fecdueNew = new Date(fecdue);
    if (f_a > fecdueNew && Number(idxstatus) < 2) {
        idxstatus = "4"; // retorno de estado "overdue" 4 como string
    }
    return idxstatus;
};
export default isOverdue;
